import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 11.505 11.505"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.454.265A.479.479 0 0 0 11.025 0H.479A.479.479 0 0 0 .1.767l4.214 5.668v4.112a.966.966 0 0 0 .959.959.955.955 0 0 0 .575-.192l.959-.719a.962.962 0 0 0 .383-.767V6.435L11.409.767a.479.479 0 0 0 .045-.5Zm-8.854.79 1.885 2.516a.24.24 0 0 1 .048.144v.6a.24.24 0 0 1-.431.144L1.735 1.342a.24.24 0 0 1 .192-.383h.479a.24.24 0 0 1 .194.096Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }